import React, {useState, useEffect} from 'react';
import { useSpring, animated, useSpringRef } from 'react-spring'; 

const KenBurnsImage = ({img, active, kenBurnsZoom, setFinishLoadImage}) => {
    const propsRef = useSpringRef();
    let props = useSpring({
        from: {
            transform: 'scale(1)',
          },
        to: {
            transform: 'scale(1.5)',
          },
        config: {
            duration: 8000,
          },
        ref: propsRef,
    });
    useEffect(() => {
        if (active) {
            propsRef.start(kenBurnsZoom);
        }
        else {
            setTimeout(() => {
                propsRef.start({
                    from: {
                        transform: 'scale(1)'
                    },
                    to: {
                        transform: 'scale(1)',
                    },
                    config: {
                        duration: 8000,
                    },
                });
            }, 500)
        }
    }, [kenBurnsZoom])
    
    return (
        <animated.div>
            <animated.img className="kenburns_image" 
                src={img}
                style={{...props, 
                    overflow: 'hidden'
                }} 
                onLoad={(e) => {
                    e.target.decode().then(() => setFinishLoadImage(true)).catch(() => setFinishLoadImage(true));
                }}/>
        </animated.div>
    ) 

}

export default KenBurnsImage;